// @generated by protoc-gen-es v2.6.3 with parameter "keep_empty_files=true,target=js+dts"
// @generated from file proto/model/booking/booking_participant.proto (package carmen, syntax proto3)
/* eslint-disable */

import { enumDesc, fileDesc, messageDesc, tsEnum } from "@bufbuild/protobuf/codegenv2";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import { file_proto_model_core_model_path } from "../core/model_path_pb";
import { file_proto_model_entity_person } from "../entity/person_pb";
import { file_proto_model_entity_contact } from "../entity/contact_pb";
import { file_proto_model_core_common } from "../core/common_pb";

/**
 * Describes the file proto/model/booking/booking_participant.proto.
 */
export const file_proto_model_booking_booking_participant = /*@__PURE__*/
  fileDesc("Ci1wcm90by9tb2RlbC9ib29raW5nL2Jvb2tpbmdfcGFydGljaXBhbnQucHJvdG8SBmNhcm1lbiLmAwoSQm9va2luZ1BhcnRpY2lwYW50EhYKDnBhcnRpY2lwYW50X2lkGAEgASgJEisKDXRyYXZlbGVyX3BhdGgYAiABKAsyFC5jYXJtZW4uVHJhdmVsZXJQYXRoEisKB2NyZWF0ZWQYAyABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wEiwKCG1vZGlmaWVkGAQgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcBInCg9wZXJzb25fc25hcHNob3QYBSABKAsyDi5jYXJtZW4uUGVyc29uEj0KDXN5bmNfbWV0YWRhdGEYBiABKAsyJi5jYXJtZW4uQm9va2luZ1BhcnRpY2lwYW50U3luY01ldGFkYXRhEjQKEmVtZXJnZW5jeV9jb250YWN0cxgHIAMoCzIYLmNhcm1lbi5FbWVyZ2VuY3lDb250YWN0EhgKEHNwZWNpYWxfcmVxdWVzdHMYCCADKAkSQwoNcHJvdmlkZXJfZGF0YRgJIAMoCzIsLmNhcm1lbi5Cb29raW5nUGFydGljaXBhbnQuUHJvdmlkZXJEYXRhRW50cnkaMwoRUHJvdmlkZXJEYXRhRW50cnkSCwoDa2V5GAEgASgJEg0KBXZhbHVlGAIgASgJOgI4ASJ2ChBFbWVyZ2VuY3lDb250YWN0EgwKBG5hbWUYASABKAkSFAoMcmVsYXRpb25zaGlwGAIgASgJEg0KBXBob25lGAMgASgJEg0KBWVtYWlsGAQgASgJEiAKB2FkZHJlc3MYBSABKAsyDy5jYXJtZW4uQWRkcmVzcyLZAQoeQm9va2luZ1BhcnRpY2lwYW50U3luY01ldGFkYXRhEi0KCWxhc3Rfc3luYxgBIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXASMgoLZGF0YV9zb3VyY2UYAiABKA4yHS5jYXJtZW4uUGFydGljaXBhbnREYXRhU291cmNlEg8KB3ZlcnNpb24YAyABKAMSJwoLc3luY19zdGF0dXMYBCABKA4yEi5jYXJtZW4uU3luY1N0YXR1cxIaChJsYXN0X2Vycm9yX21lc3NhZ2UYBSABKAkqYgoRQm9va2luZ1N5bmNTdGF0dXMSIwofQk9PS0lOR19TWU5DX1NUQVRVU19VTlNQRUNJRklFRBAAEigKJEJPT0tJTkdfU1lOQ19TVEFUVVNfVFJBVkVMRVJfREVMRVRFRBAKKvABChVQYXJ0aWNpcGFudERhdGFTb3VyY2USJwojUEFSVElDSVBBTlRfREFUQV9TT1VSQ0VfVU5TUEVDSUZJRUQQABIpCiVQQVJUSUNJUEFOVF9EQVRBX1NPVVJDRV9UUkFWRUxFUl9TWU5DEAESKAokUEFSVElDSVBBTlRfREFUQV9TT1VSQ0VfTUFOVUFMX0VOVFJZEAISKwonUEFSVElDSVBBTlRfREFUQV9TT1VSQ0VfUFJPVklERVJfSU1QT1JUEAMSLAooUEFSVElDSVBBTlRfREFUQV9TT1VSQ0VfUFJFVklPVVNfQk9PS0lORxAEQjBaLmdpdGh1Yi5jb20veXVuYWNhYmEvY2FybWVuL3Byb3RvL21vZGVsL2Jvb2tpbmdiBnByb3RvMw", [file_google_protobuf_timestamp, file_proto_model_core_model_path, file_proto_model_entity_person, file_proto_model_entity_contact, file_proto_model_core_common]);

/**
 * Describes the message carmen.BookingParticipant.
 * Use `create(BookingParticipantSchema)` to create a new message.
 */
export const BookingParticipantSchema = /*@__PURE__*/
  messageDesc(file_proto_model_booking_booking_participant, 0);

/**
 * Describes the message carmen.EmergencyContact.
 * Use `create(EmergencyContactSchema)` to create a new message.
 */
export const EmergencyContactSchema = /*@__PURE__*/
  messageDesc(file_proto_model_booking_booking_participant, 1);

/**
 * Describes the message carmen.BookingParticipantSyncMetadata.
 * Use `create(BookingParticipantSyncMetadataSchema)` to create a new message.
 */
export const BookingParticipantSyncMetadataSchema = /*@__PURE__*/
  messageDesc(file_proto_model_booking_booking_participant, 2);

/**
 * Describes the enum carmen.BookingSyncStatus.
 */
export const BookingSyncStatusSchema = /*@__PURE__*/
  enumDesc(file_proto_model_booking_booking_participant, 0);

/**
 * Booking-specific sync status extending common SyncStatus
 * Use common SyncStatus for: SYNCHRONIZED, STALE, ERROR, IN_PROGRESS
 * This enum adds booking-specific status values
 *
 * @generated from enum carmen.BookingSyncStatus
 */
export const BookingSyncStatus = /*@__PURE__*/
  tsEnum(BookingSyncStatusSchema);

/**
 * Describes the enum carmen.ParticipantDataSource.
 */
export const ParticipantDataSourceSchema = /*@__PURE__*/
  enumDesc(file_proto_model_booking_booking_participant, 1);

/**
 * @generated from enum carmen.ParticipantDataSource
 */
export const ParticipantDataSource = /*@__PURE__*/
  tsEnum(ParticipantDataSourceSchema);

